import { RouteConfig } from '@dfl/react-security';
import { lazy } from 'react';
import { CookiesPolicies, PrivacyPolicies, TermsConditions } from 'modules/common/pages';

const loadMainApp = () => import('routes/MainApp');
export const MainApp = lazy(loadMainApp);

const loadAuthApp = () => import('routes/AuthApp');
export const AuthApp = lazy(loadAuthApp);

export const routes: RouteConfig = {
  Auth: {
    path: '/auth/*',
    onlyAnonymous: true,
    component: AuthApp,
  },
  Terms: {
    path: '/terms',
    component: TermsConditions,
  },
  Cookies: {
    path: '/politicadecookies',
    component: CookiesPolicies,
  },
  Privacy: {
    path: '/privacy',
    component: PrivacyPolicies,
  },
  MainLayout: {
    path: '*',
    authenticated: true,
    redirect: '/auth/login',
    component: MainApp,
  },
};
